import React, { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'

import Loading from '@/components/UI/Loading/Loading'
import { Crisp } from 'crisp-sdk-web'
import { useSelector } from 'react-redux'
import { getCommonUserDetails } from '@/store/common/selector'

const Support = () => {
  // Retrieve optional path segment from route params (e.g. /support/:path?)
  const userDetails = useSelector(getCommonUserDetails)

  // Configure and show Crisp on mount; hide on unmount
  useEffect(() => {
    Crisp.configure('485af985-cb65-4216-83bf-523fa4bf140a', {
      cookieDomain: window.location.hostname, // Scope cookies to current domain only
    })
    Crisp.chat.show()

    return () => {
      // Hide Crisp chat when component is unloaded
      Crisp.chat.hide()
    }
  }, [])

  // Update Crisp user info when userDetails becomes available/changes
  useEffect(() => {
    if (userDetails?.email) {
      Crisp.user.setEmail(userDetails.email)
    }
    if (userDetails?.full_name) {
      Crisp.user.setNickname(userDetails.full_name)
    }
  }, [userDetails])

  const { path } = useParams<{ path: string }>()
  const history = useHistory()
  const query = new URLSearchParams(history.location.search)
  const spUrl = `https://noodlefactorysupport.super.site/${path || ''}`

  const [iframeLoading, setIframeLoading] = useState(true)
  const iframeLoadedHandler = () => setIframeLoading(false)

  const forcedSrc = query.get('force')
  const iframeSrc = forcedSrc ? forcedSrc : spUrl

  return (
    <>
      {iframeLoading && <Loading />}
      <section className="page-mid-wraper h-without-foter pb-0 p-0">
        <div className="h-100 p-0">
          <div className="h-100">
            <div className="h-100">
              <iframe
                id="myframe"
                src={iframeSrc}
                title="Support"
                className="full-iframe"
                allowFullScreen
                onLoad={iframeLoadedHandler}
              ></iframe>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Support
